import SchemaOrg from 'components/schema-org';
import styles from './style.module.scss';
import { listingCardIds } from 'constants/test-constants';
import { MouseEventHandler } from 'react';
import { PropsWithDataAttributes } from 'types/react';

type AddressProps = PropsWithDataAttributes<{
  fullAddress?: string;
  street?: string;
  city?: string;
  province?: string;
  position?: {
    latitude: number;
    longitude: number;
  };
  onAddressClick?: MouseEventHandler<HTMLElement>;
}>;

export default function Address(props: AddressProps) {
  const { fullAddress, street, city, province, position, onAddressClick, ...dataAttributes } = props;
  return (
    <SchemaOrg itemType="SingleFamilyResidence">
      <SchemaOrg itemProp="address" itemType="PostalAddress">
        <div className={styles['street-address']} data-testid={listingCardIds.listingAddress}>
          <p className={styles.link} onClick={onAddressClick} {...dataAttributes}>{fullAddress}</p>
        </div>
        <meta itemProp="streetAddress" content={street || ''} />
        <meta itemProp="addressLocality" content={city || ''} />
        <meta itemProp="addressRegion" content={province || ''} />
      </SchemaOrg>
      <SchemaOrg itemProp="geo" itemType="GeoCoordinates">
        <meta itemProp="latitude" content={position ? position.latitude.toString() : ''} />
        <meta itemProp="longitude" content={position ? position.longitude.toString() : ''} />
      </SchemaOrg>
    </SchemaOrg>
  );
}